<template>
  <div class="productsCarousel">
    <div class="content" >
      <div class="anis" :style="{'height':aniHeight+'px'}">
        <div class="ani" :id="item.name" v-for="(item,i) in anis" :class="boxClass(i)"></div>
      </div>
      <div class="detail">
        <div class="icons">
          <div class="icon" v-for="(item,i) in anis" :class="boxClass(i)" @click="clickDot(i)">
            <img :src="item.icon" alt="">
          </div>
        </div>
        <div class="titles">
          <div class="title" v-for="(item,i) in anis" v-text="item.title" :class="boxClass(i)"></div>
        </div>
        <div class="descs">
          <div class="desc" v-for="(item,i) in anis" v-html="item.desc" :class="boxClass(i)"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const lottoi_con = require('@/assets/about/lottoi_con.png');
const marble_icon = require('@/assets/about/marble_icon.png');
const mini_icon = require('@/assets/about/mini_icon.png');
const ares_icon = require('@/assets/about/ares_icon.png');
const aeon_icon = require('@/assets/about/aeon_icon.png');

export default {
  name: "productsCarousel",
  data() {
    return {
      nowIndex: 0,
      animate: false,
      timeout: 5000,
      wWidth: 0,
      aniHeight: 0,
      interval: {},
      anis: [
        {
          name: 'aeonani',
          type:'about/aeon bet',
          fileName:'aboutimage',
          title: 'AeonBet Games',
          icon: aeon_icon,
          desc: '<span style="display: block;margin-bottom: 1rem;"> AEON BET adopts the latest technology to provide you with a friendly and concise operation interface, verifiable fairness mechanism per round and more betting types. Still playing old age games? Come and try the latest game of AEON BET!</span>'
        },
        {
          name: 'aresbetani',
          type:'about/ares bet',
          fileName:'aboutimage',
          title: 'Aresbet Games',
          icon: ares_icon,
          desc: '<span style="display: block;margin-bottom: 1rem;"> ARES BET is a revolutional product based on sci-fict theme. Its simple and refreshing interface design plus a user-friendly UI will give you a brand new experience of the future.</span>'
        },
        {
          name: 'miniani',
          type:'about/mini',
          fileName:'aboutimage',
          title: 'Mini Games',
          icon: mini_icon,
          desc: '<span style="display: block;margin-bottom: 1rem;">Arcadia Mini Games is our top grossing product enjoyed by many across the globe. Till date, over 100 million rounds have been played in our partnering platforms. Every game within our Mini Games collection was hand-picked specially from popular classic games from various countries by our dedicated market surveyors and perfected through creative innovation.</span>' +
              '<span>Best of all, Arcadia Mini Games can be easily embedded onto every platform’s main page as it uses only a fraction of space! Our simple, yet addictive Mini Games has proven successful in engaging players and retaining players. Try out our Mini Games and contact us today for integration!</span>'
        },
        {
          name: 'marbleani',
          type:'about/marble mini',
          fileName:'aboutimage',
          title: 'Marble Games',
          icon: marble_icon,
          desc: '<span style="display: block;margin-bottom: 1rem;">Arcadia Marble Games is the latest addition to our line of products. Inspired by popular live marble racing games from the European regions, our team has replicated the game and managed to successfully digitalise the concept into an online game.</span>' +
              '<span>Boasting an exciting, lively and interactive gameplay, Marble Games has been well-received by our early adopters and continues to grow in player base. Due to the favourable response, our team is currently working on more marble game types. Try out our Marble Games and be the early birds to snap up the newest game in town!</span>'
        },
        {
          name: 'lottoani',
          type:'about/lotto world',
          fileName:'aboutimage',
          title: 'Lotto Games',
          icon: lottoi_con,
          desc: '<span style="display: block;margin-bottom: 1rem;">Arcadia Lotto Games is a Lotto-based game popular in selected regions of South-East Asia. Contrary to various Lotto games offered in the industry today, Arcadia Lotto Games are infused with innovative game elements which makes it more enjoyable.</span>' +
              '<span>More ways to win, faster lottery draws, more prizes to win will excite your players every draw! We promise that this type of new-gen lottery will engage your players at a much better rate than any other lottery products in the market. Try out our Lotto Games to experience the next level of lottery!\n</span>'
        },
      ],
    }
  },
  computed: {
    games() {
      return this.$dataManager.findGamesByType(this.type)
    },
    total() {
      return this.anis.length
    },
    prev() {
      return (this.nowIndex - 1 < 0) ? this.total - 1 : this.nowIndex - 1
    },
    after() {
      return (this.nowIndex + 1 === this.total) ? 0 : this.nowIndex + 1
    },
  },
  methods: {
    clickDot: function (idx) {
      var $this = this
      clearInterval(this.interval)
      this.nowIndex = idx
      this.interval = setInterval(() => {
        this.nowIndex++
      }, $this.timeout)
    },
    change: function (i) {
      if (!this.animate) {
        this.nowIndex += i
        var $this = this;
        $this.animate = true
        this.timeout = setTimeout(() => {
          $this.animate = false
        }, 305)
      }
    },
    boxClass(idx) {
      return (idx == this.nowIndex) ? 'now' : (idx == this.prev) ? 'pre' : (idx == this.after) ? 'after' : ''
    },
    dotClass(idx) {
      return (idx == this.nowIndex) ? 'now' : ''
    },
    animation: function () {
      this.anis.forEach((i) => {
        var credentials = {
          type:i.type,
          file:i.fileName,
        }
        this.$store.dispatch('loadAni', {credentials: credentials}).then((res) => {
          let param = {
            container: document.getElementById(i.name),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: res.data
          };
          lottie.loadAnimation(param);
          this.aniHeight = document.querySelector('.ani.now').getBoundingClientRect().height
        })
      })

    }
  },
  mounted: function () {
    var $this = this
    this.animation()
    this.wWidth = window.innerWidth
    this.interval = setInterval(() => {
      this.wWidth = window.innerWidth
      this.nowIndex++
    }, $this.timeout)
    window.onresize = () => {
      return (() => {
        let aniH = document.querySelector('.ani.now').getBoundingClientRect().height
        $this.aniHeight = aniH
      })()
    }
  },
  watch: {
    nowIndex(val, old) {
      this.aniHeight = document.querySelector('.ani.now').getBoundingClientRect().height
      if (val == this.total) {
        this.nowIndex = 0
      }
      if (val < 0) {
        this.nowIndex = this.total - 1
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import 'productsCarousel';
</style>
